import React from 'react';

const EdgeIcon = () => {
  return (
    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.6959 18.6054C22.3623 18.7797 22.0183 18.9333 21.6658 19.0654C20.5438 19.4848 19.3552 19.6985 18.1572 19.6961C13.5324 19.6961 9.50386 16.5178 9.50386 12.4391C9.50978 11.8921 9.66172 11.3566 9.944 10.8878C10.2263 10.419 10.6287 10.034 11.1096 9.77246C6.92663 9.94822 5.85156 14.3032 5.85156 16.8547C5.85156 24.0687 12.5062 24.8 13.94 24.8C14.713 24.8 15.879 24.5755 16.5788 24.3548L16.7068 24.3118C19.3996 23.3817 21.6952 21.5634 23.2158 19.1562C23.2624 19.0828 23.2832 18.9961 23.2749 18.9097C23.2667 18.8232 23.2298 18.742 23.1702 18.6789C23.1105 18.6157 23.0315 18.5742 22.9456 18.5609C22.8597 18.5476 22.7719 18.5633 22.6959 18.6054Z"
        fill="url(#paint0_linear_2802_182)"
      />
      <path
        opacity="0.35"
        d="M22.6959 18.6054C22.3623 18.7797 22.0183 18.9333 21.6658 19.0654C20.5438 19.4848 19.3552 19.6985 18.1572 19.6961C13.5324 19.6961 9.50386 16.5178 9.50386 12.4391C9.50978 11.8921 9.66172 11.3566 9.944 10.8878C10.2263 10.419 10.6287 10.034 11.1096 9.77246C6.92663 9.94822 5.85156 14.3032 5.85156 16.8547C5.85156 24.0687 12.5062 24.8 13.94 24.8C14.713 24.8 15.879 24.5755 16.5788 24.3548L16.7068 24.3118C19.3996 23.3817 21.6952 21.5634 23.2158 19.1562C23.2624 19.0828 23.2832 18.9961 23.2749 18.9097C23.2667 18.8232 23.2298 18.742 23.1702 18.6789C23.1105 18.6157 23.0315 18.5742 22.9456 18.5609C22.8597 18.5476 22.7719 18.5633 22.6959 18.6054Z"
        fill="url(#paint1_radial_2802_182)"
      />
      <path
        d="M10.4462 23.5735C9.57443 23.033 8.81897 22.3247 8.2237 21.4898C7.54522 20.5611 7.07833 19.4953 6.85578 18.3672C6.63323 17.2391 6.66041 16.076 6.9354 14.9596C7.2104 13.8431 7.72655 12.8002 8.44767 11.9041C9.16878 11.0081 10.0774 10.2805 11.1098 9.77237C11.4147 9.62883 11.9356 9.3691 12.6285 9.38179C13.1167 9.38534 13.5975 9.5018 14.0331 9.72203C14.4687 9.94226 14.8473 10.2603 15.1393 10.6512C15.534 11.1777 15.7516 11.8155 15.7609 12.4732C15.7609 12.4527 18.1514 4.70068 7.94222 4.70068C3.65173 4.70068 0.123557 8.76858 0.123557 12.3375C0.106633 14.2254 0.510946 16.0934 1.30711 17.8056C2.60826 20.5793 4.88362 22.779 7.70111 23.9871C10.5186 25.1951 13.682 25.3273 16.5906 24.3586C15.5722 24.6794 14.4963 24.7757 13.437 24.6409C12.3777 24.506 11.3603 24.1432 10.4549 23.5774L10.4462 23.5735Z"
        fill="url(#paint2_linear_2802_182)"
      />
      <path
        opacity="0.41"
        d="M10.4462 23.5735C9.57443 23.033 8.81897 22.3247 8.2237 21.4898C7.54522 20.5611 7.07833 19.4953 6.85578 18.3672C6.63323 17.2391 6.66041 16.076 6.9354 14.9596C7.2104 13.8431 7.72655 12.8002 8.44767 11.9041C9.16878 11.0081 10.0774 10.2805 11.1098 9.77237C11.4147 9.62883 11.9356 9.3691 12.6285 9.38179C13.1167 9.38534 13.5975 9.5018 14.0331 9.72203C14.4687 9.94226 14.8473 10.2603 15.1393 10.6512C15.534 11.1777 15.7516 11.8155 15.7609 12.4732C15.7609 12.4527 18.1514 4.70068 7.94222 4.70068C3.65173 4.70068 0.123557 8.76858 0.123557 12.3375C0.106633 14.2254 0.510946 16.0934 1.30711 17.8056C2.60826 20.5793 4.88362 22.779 7.70111 23.9871C10.5186 25.1951 13.682 25.3273 16.5906 24.3586C15.5722 24.6794 14.4963 24.7757 13.437 24.6409C12.3777 24.506 11.3603 24.1432 10.4549 23.5774L10.4462 23.5735Z"
        fill="url(#paint3_radial_2802_182)"
      />
      <path
        d="M15.001 14.5355C14.9218 14.638 14.6785 14.7796 14.6785 15.0881C14.6785 15.343 14.8446 15.5881 15.1398 15.7941C16.5452 16.7706 19.1947 16.6417 19.2016 16.6417C20.243 16.6392 21.2646 16.3576 22.16 15.8263C23.0632 15.2994 23.8129 14.5457 24.3346 13.6399C24.8563 12.7342 25.1319 11.7079 25.134 10.6628C25.1594 8.47462 24.3521 7.01971 24.0257 6.37525C21.9547 2.32786 17.4844 6.11886e-08 12.6231 6.11886e-08C9.33558 -0.000324726 6.18002 1.29233 3.83896 3.59839C1.49789 5.90445 0.159513 9.03854 0.113281 12.3228C0.160193 8.75486 3.70987 5.87336 7.93195 5.87336C8.27402 5.87336 10.2248 5.90655 12.0367 6.85664C13.6337 7.69444 14.4703 8.70604 15.0518 9.70886C15.6558 10.7507 15.7633 12.067 15.7633 12.5913C15.7633 13.1157 15.4955 13.893 15.001 14.5355Z"
        fill="url(#paint4_radial_2802_182)"
      />
      <path
        d="M15.001 14.5355C14.9218 14.638 14.6785 14.7796 14.6785 15.0881C14.6785 15.343 14.8446 15.5881 15.1398 15.7941C16.5452 16.7706 19.1947 16.6417 19.2016 16.6417C20.243 16.6392 21.2646 16.3576 22.16 15.8263C23.0632 15.2994 23.8129 14.5457 24.3346 13.6399C24.8563 12.7342 25.1319 11.7079 25.134 10.6628C25.1594 8.47462 24.3521 7.01971 24.0257 6.37525C21.9547 2.32786 17.4844 6.11886e-08 12.6231 6.11886e-08C9.33558 -0.000324726 6.18002 1.29233 3.83896 3.59839C1.49789 5.90445 0.159513 9.03854 0.113281 12.3228C0.160193 8.75486 3.70987 5.87336 7.93195 5.87336C8.27402 5.87336 10.2248 5.90655 12.0367 6.85664C13.6337 7.69444 14.4703 8.70604 15.0518 9.70886C15.6558 10.7507 15.7633 12.067 15.7633 12.5913C15.7633 13.1157 15.4955 13.893 15.001 14.5355Z"
        fill="url(#paint5_radial_2802_182)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2802_182"
          x1="5.85156"
          y1="17.2882"
          x2="23.2813"
          y2="17.2882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0C59A4" />
          <stop offset="1" stopColor="#114A8B" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2802_182"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.4783 17.4254) scale(9.3218 8.84772)"
        >
          <stop offset="0.72" stopOpacity="0" />
          <stop offset="0.95" stopOpacity="0.53" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_2802_182"
          x1="15.0406"
          y1="9.73429"
          x2="4.16475"
          y2="21.5914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B9DE2" />
          <stop offset="0.16" stopColor="#1595DF" />
          <stop offset="0.67" stopColor="#0680D7" />
          <stop offset="1" stopColor="#0078D4" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_2802_182"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.01224 19.4322) rotate(-81.3767) scale(14.0051 11.3245)"
        >
          <stop offset="0.76" stopOpacity="0" />
          <stop offset="0.95" stopOpacity="0.5" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_2802_182"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.64091 4.62611) rotate(92.2927) scale(19.7821 42.1698)"
        >
          <stop stopColor="#35C1F1" />
          <stop offset="0.11" stopColor="#34C1ED" />
          <stop offset="0.23" stopColor="#2FC2DF" />
          <stop offset="0.31" stopColor="#2BC3D2" />
          <stop offset="0.67" stopColor="#36C752" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_2802_182"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.5763 7.55833) rotate(73.7259) scale(9.50545 7.73572)"
        >
          <stop stopColor="#66EB6E" />
          <stop offset="1" stopColor="#66EB6E" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default EdgeIcon;